import { render } from "./BoolText.vue?vue&type=template&id=6f2a2853"
import script from "./BoolText.vue?vue&type=script&lang=js"
export * from "./BoolText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__